module.exports = __webpack_public_path__ + "img/study_statitle_bg1.9e002d0c.png";